import { FCWithChildren } from '@types';
import React, { Fragment, useEffect, useRef } from 'react';

import { ActionSection, RequestManagerWrapper, SharedList, Tabs } from '@components';

import { useAppContext } from '@contexts/AppContext';
import useLayoutContext from '@hooks/useLayoutContext';

import Steps from './components/Steps';
import MyDevices from './components/MyDevices';
import Instructions from './components/Instructions';
import SetUpPassword from './components/SetUpPassword';
import usePageTitle from '@hooks/usePageTitle';
import { MdImportantDevices } from 'react-icons/md';

type ManageDevicesProps = {
  location?: {
    state: { isAddingDevice: boolean };
  };
};

const ManageDevices: FCWithChildren<ManageDevicesProps> = ({ location }) => {
  usePageTitle('Network');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ActionSection className="my-10">
      <ActionSection.Header icon={<MdImportantDevices size={80} />}>
        Shared Network
      </ActionSection.Header>
      <ActionSection.Body>
        <RequestManagerWrapper>
          <SharedList />
        </RequestManagerWrapper>
      </ActionSection.Body>
    </ActionSection>
  );
};
export default ManageDevices;
